import React, { Component } from "react";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import { MessageTypeEnum } from "../../enums";
import confirmService from "./confirmService";

class DialogWindow extends Component {
    state = {
        show: false,
        showClosingConfirmDialog: false,
        confirmDialogShouldBeOpened: false
    };

    shouldComponentUpdate(nextProps) {
        if (this.props.dialog !== nextProps.dialog) {
            this.setState({
                show: true
            });
        }

        return true;
    }

    componentDidUpdate() {
        var dialogContent = document.getElementsByClassName("k-content k-window-content k-dialog-content")[0];
        if (dialogContent) {
            var autoFocus = dialogContent.getElementsByClassName("auto-focus")[0];
            if (autoFocus) {
                autoFocus.focus();
            }
        }
    }

    allowOpeningConfirmDialog = () => {
        this.setState({
            confirmDialogShouldBeOpened: true
        });
    };

    onClose = () => {
        if (this.props.dialog.hasClosingConfirmDialog && this.state.confirmDialogShouldBeOpened) {
            this.setState({
                showClosingConfirmDialog: true
            });
        } else {
            this.closeDialog(true);
        }
    };

    closeDialog = isByCloseButton => {
        this.setState(
            {
                show: false,
                dialog: {
                    title: null,
                    content: null,
                    width: null,
                    height: null
                },
                showClosingConfirmDialog: false,
                confirmDialogShouldBeOpened: false
            },
            () => {
                if (this.props.dialog.extraClosingCallback) {
                    this.props.dialog.extraClosingCallback(isByCloseButton);
                }
            }
        );
    };

    closeConfirmDialog = () => {
        this.setState({
            showClosingConfirmDialog: false
        });
    };

    toggleErrorDialog = async message => {
        await confirmService.show({
            type: MessageTypeEnum.CRITICAL,
            message: message,
            logMessage: true
        });
    };

    render() {
        return (
            <React.Fragment>
                {this.state.show && (
                    <Dialog title={this.props.dialog.title} width={this.props.dialog.width} height={this.props.dialog.height} onClose={this.onClose}>
                        {this.props.dialog.content(
                            this.closeDialog,
                            this.state.showClosingConfirmDialog,
                            this.allowOpeningConfirmDialog,
                            this.toggleErrorDialog,
                            this.closeConfirmDialog
                        )}
                    </Dialog>
                )}
            </React.Fragment>
        );
    }
}

export default DialogWindow;



// WEBPACK FOOTER //
// ./src/components/common/DialogWindow.js